<template>
  <div class="footer-nav" v-if="show">
    <van-tabbar
      v-model="active"
      active-color="#7c6ff0"
      :border="false"
      inactive-color="#9ca3af"
      z-index="999"
    >
      <van-tabbar-item to="/Home">
        <span>{{ $t("foorter.index") }}</span>
        <template #icon="props">
          <img
            :src="props.active ? '/img/footer/indexed.png' : '/img/footer/index.png'"
            :alt="$t('foorter.index')"
            class="tab-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item @click="handleVideoClick">
        <span>{{ $t("foorter.subscribe") }} </span>
        <template #icon="props">
          <img
            :src="props.active ? '/img/footer/yingyuaned.png' : '/img/footer/yingyuan.png'"
            :alt="$t('foorter.subscribe')"
            class="tab-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/Choose">
        <span>{{ $t("foorter.xuanfei") }}</span>
        <template #icon="props">
          <img
            :src="props.active ? '/img/footer/xuanfeied.png' : '/img/footer/xuanfei.png'"
            :alt="$t('foorter.xuanfei')"
            class="tab-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/Lottery">
        <span>{{ $t("foorter.video") }}</span>
        <template #icon="props">
          <img
            :src="props.active ? '/img/footer/toupiaoed.png' : '/img/footer/toupiao.png'"
            :alt="$t('foorter.video')"
            class="tab-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/Mine">
        <span>{{ $t("foorter.my") }}</span>
        <template #icon="props">
          <img
            :src="props.active ? '/img/footer/myed.png' : '/img/footer/my.png'"
            :alt="$t('foorter.my')"
            class="tab-icon"
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      show: false,
      active: 0,
      userInfo: {}
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  watch: {
    $route(to) {
      this.updateActive(to);
    },
  },
  created() {
    this.updateActive(this.$route);
  },
  mounted() {
    // 监听用户登录状态变化
    window.addEventListener('userInfoUpdated', this.handleUserInfoUpdate);
    // 从 store 获取用户信息
    if (this.$store.state.userInfo && Object.keys(this.$store.state.userInfo).length > 0) {
      this.userInfo = this.$store.state.userInfo;
    } else {
      // 如果 store 中没有用户信息，则请求获取
      this.fetchUserInfo();
    }
  },
  beforeDestroy() {
    window.removeEventListener('userInfoUpdated', this.handleUserInfoUpdate);
  },
  methods: {
    ...mapMutations(['setUserInfoValue']),
    handleUserInfoUpdate(event) {
      this.userInfo = event.detail;
    },
    updateActive(route) {
      const routeMap = {
        home: 0,
        video: 1,
        choose: 2,
        Lottery: 3,
        mine: 4,
      };
      const idx = routeMap[route.name];
      if (idx !== undefined) {
        this.active = idx;
        this.show = true;
      } else {
        this.show = false;
      }
    },
    handleVideoClick() {
      // 检查用户VIP等级是否 >= VIP1
      const vipLevel = this.getVipLevel();
      if (vipLevel >= 1) {
        this.$router.push('/Video');
      } else {
        this.$toast(this.$t("common.vip_required"));
      }
    },
    getVipLevel() {
      // 从 vipname 中提取 VIP 等级数字
      // vipname 格式可能是 "vip0", "vip1", "vip2" 等
      if (this.userInfo.vipname) {
        const match = this.userInfo.vipname.match(/vip(\d+)/i);
        if (match) {
          return parseInt(match[1], 10);
        }
      }
      return 0;
    },
    fetchUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.setUserInfoValue(res.data);
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 100px;

.footer-nav {
  .van-tabbar {
    height: @tabbar-height;
    background: rgba(255, 255, 255, 0.78);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-top: none;
    box-shadow: 0 -4px 24px rgba(31, 41, 55, 0.06);
  }

  .van-tabbar-item {
    font-size: 22px;

    .tab-icon {
      height: 48px;
      width: 48px;
      object-fit: contain;
      transition: transform 0.2s ease;
    }

    &.van-tabbar-item--active {
      .tab-icon {
        transform: scale(1.08);
      }
    }
  }
}
</style>
